import React, { useCallback } from "react";
import { Card, Heading, Box, Flex, Button } from "theme-ui";
import { useLiquitySelector } from "@liquity/lib-react";
import { LiquityStoreState } from "@liquity/lib-base";
import { DisabledEditableRow } from "./Editor";
import { useTroveView } from "./context/TroveViewContext";
import { Icon } from "../Icon";
import { COIN } from "../../strings";
import { CollateralRatio } from "./CollateralRatio";
import BalanceLabel from "../BalanceLabel/BalanceLabel";
import useChain from "../../hooks/useChain";

const select = ({ trove, price, accountBalance }: LiquityStoreState) => ({
  trove,
  price,
  accountBalance
});

export const ReadOnlyTrove: React.FC = () => {
  const { dispatchEvent } = useTroveView();
  const chain = useChain();
  const currencySymbol = chain.nativeCurrency.symbol;

  const handleAdjustTrove = useCallback(() => {
    dispatchEvent("ADJUST_TROVE_PRESSED");
  }, [dispatchEvent]);
  const handleCloseTrove = useCallback(() => {
    dispatchEvent("CLOSE_TROVE_PRESSED");
  }, [dispatchEvent]);

  const { trove, price, accountBalance } = useLiquitySelector(select);

  // console.log("READONLY TROVE", trove.collateral.prettify(4));
  return (
    <Card>
      <Heading>
        Trove
        <Button
          onClick={handleAdjustTrove}
          sx={{
            bg: "white",
            color: "#000000",
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            px: 2,
            py: 1,
            fontSize: 1,
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
            transition: "all 0.2s",
            ":hover": {
              bg: "#F9FAFB",
              borderColor: "#D1D5DB",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
            }
          }}
        >
          <Icon name="pen" size="sm" />
          Adjust
        </Button>
      </Heading>
      <Box sx={{ p: [2, 3], display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ flex: 1 }}>
          <DisabledEditableRow
            label="Collateral"
            trailingLabel={
              <BalanceLabel balance={accountBalance.toString()} tokenSymbol={currencySymbol} />
            }
            inputId="trove-collateral"
            amount={trove.collateral.prettify(4)}
            unit={currencySymbol}
          />

          <DisabledEditableRow
            label="Debt"
            inputId="trove-debt"
            amount={trove.debt.prettify()}
            unit={COIN}
          />

          <CollateralRatio value={trove.collateralRatio(price)} />
        </Box>

        <Flex variant="layout.actions">
          <Button variant="cancel" onClick={handleCloseTrove}>
            Close Trove
          </Button>
        </Flex>
      </Box>
    </Card>
  );
};
